import { Type } from "class-transformer";
import { ClientSummaryListOutDTO } from "./client-summary-list.out.dto";

export class ClientPaginatedOutDTO {
  @Type(() => ClientSummaryListOutDTO)
  clients!: ClientSummaryListOutDTO[];

  total!: number;
}
